module.exports = __webpack_public_path__ + "media/images/shared/arrow-white-right-large-6e3c9997e58db7b59d9085e55b67df94.png";